import ACTIONS, { FETCH_STATUS } from '../app.constants';
import {
    AccountingTransactionList,
    Appointment,
    AppointmentType,
    CommentList,
    Form,
    LicenseList,
    InspectionList,
    Inspection,
    AuditHistoryList,
} from '../modules/application/types';
import { Contact, Person, PersonTypeConfiguration, ContactType, EventSeries } from '../modules/person/types';
import { EventList, LimitAndSkipData } from '../modules/calendar/types';

export const getPersonDetail = {
    pending: {
        type: ACTIONS.GET_PERSON_DETAIL.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (person: Person, editForm: Form | undefined, personType: PersonTypeConfiguration | undefined) => ({
        type: ACTIONS.GET_PERSON_DETAIL.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: {
            person,
            editForm,
            personType,
        },
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_PERSON_DETAIL.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getPersonContactDetail = {
    pending: {
        type: ACTIONS.GET_PERSON_CONTACTS.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (contactList: Contact, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_PERSON_CONTACTS.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: contactList,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_PERSON_CONTACTS.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getContactTypes = {
    pending: {
        type: ACTIONS.GET_CONTACT_TYPES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (contactTypes: ContactType[]) => ({
        type: ACTIONS.GET_CONTACT_TYPES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: contactTypes,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_CONTACT_TYPES.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};
export const getContactTypesBegin = () => {
    return {
        type: ACTIONS.GET_CONTACT_TYPES_BEGIN,
    };
};
export const getPersonAccounting = {
    pending: {
        type: ACTIONS.GET_PERSON_ACCOUNTING.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: AccountingTransactionList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_PERSON_ACCOUNTING.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_PERSON_ACCOUNTING.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const updatePerson = {
    pending: () => ({
        type: ACTIONS.UPDATE_PERSON.PENDING,
        status: FETCH_STATUS.LOADING,
    }),
    success: (data: Person) => ({
        type: ACTIONS.UPDATE_PERSON.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.UPDATE_PERSON.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addPersonContact = {
    pending: () => ({
        type: ACTIONS.ADD_PERSON_CONTACT.PENDING,
        status: FETCH_STATUS.LOADING,
    }),
    success: (data: Contact) => ({
        type: ACTIONS.ADD_PERSON_CONTACT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_PERSON_CONTACT.ERROR,
        error,
    }),
};

export const addPerson = {
    pending: {
        type: ACTIONS.ADD_PERSON.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Person) => ({
        type: ACTIONS.ADD_PERSON.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_PERSON.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};
export const updatePersonContact = {
    pending: () => ({
        type: ACTIONS.UPDATE_PERSON_CONTACT.PENDING,
        status: FETCH_STATUS.LOADING,
    }),
    success: (data: Contact) => ({
        type: ACTIONS.UPDATE_PERSON_CONTACT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.UPDATE_PERSON_CONTACT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const deleteAppointmentRecord = {
    pending: {
        type: ACTIONS.DELETE_APPOINTMENT_RECORD.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (appointmentId: string) => ({
        type: ACTIONS.DELETE_APPOINTMENT_RECORD.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { appointmentId },
    }),
    error: (error: Error) => ({
        type: ACTIONS.DELETE_APPOINTMENT_RECORD.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getPersonCommentList = {
    pending: {
        type: ACTIONS.GET_PERSON_COMMENT_LIST.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: CommentList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_PERSON_COMMENT_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_PERSON_COMMENT_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const addPersonComment = {
    pending: {
        type: ACTIONS.ADD_PERSON_COMMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: string) => ({
        type: ACTIONS.ADD_PERSON_COMMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_PERSON_COMMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};
export const deleteAppointmentRecordBegin = (appointmentId: string) => {
    return {
        type: ACTIONS.DELETE_APPOINTMENT_RECORD_BEGIN,
        payload: { appointmentId },
    };
};

export const updatePersonBegin = (data: Person, personId: string) => {
    return {
        type: ACTIONS.UPDATE_PERSON_BEGIN,
        payload: { data, personId },
    };
};

export const getPersonLicenses = {
    pending: {
        type: ACTIONS.GET_PERSON_LICENSES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: LicenseList, paginationData: LimitAndSkipData, licenseCount: number) => ({
        type: ACTIONS.GET_PERSON_LICENSES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
        licenseCount,
    }),

    error: (error: Error) => ({
        type: ACTIONS.GET_PERSON_LICENSES.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getAppointmentListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_APPOINTMENT_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const getAppointmentList = {
    pending: {
        type: ACTIONS.GET_APPOINTMENT_LIST.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: EventList, paginationData: LimitAndSkipData, appointmentCount: number) => ({
        type: ACTIONS.GET_APPOINTMENT_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
        appointmentCount,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_APPOINTMENT_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getAppointmentInspectionList = {
    pending: {
        type: ACTIONS.GET_APPOINTMENT_INSPECTION_LIST.PENDING,
    },
    success: (data: InspectionList, paginationData: LimitAndSkipData, inspectionCount: number) => ({
        type: ACTIONS.GET_APPOINTMENT_INSPECTION_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
        inspectionCount,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_APPOINTMENT_INSPECTION_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getAppointmentInspectionListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_APPOINTMENT_INSPECTION_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const addAppointmentInspection = {
    pending: {
        type: ACTIONS.ADD_APPOINTMENT_INSPECTION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Inspection) => ({
        type: ACTIONS.ADD_APPOINTMENT_INSPECTION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_APPOINTMENT_INSPECTION.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addAppointmentInspectionBegin = (data: Inspection) => {
    return {
        type: ACTIONS.ADD_APPOINTMENT_INSPECTION_BEGIN,
        payload: { data },
    };
};

export const deleteAppointmentInspection = {
    pending: {
        type: ACTIONS.DELETE_APPOINTMENT_INSPECTION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (inspectionId: string) => ({
        type: ACTIONS.DELETE_APPOINTMENT_INSPECTION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { inspectionId },
    }),
    error: (error: Error) => ({
        type: ACTIONS.DELETE_APPOINTMENT_INSPECTION.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const deleteAppointmentInspectionBegin = (inspectionId: string) => {
    return {
        type: ACTIONS.DELETE_APPOINTMENT_INSPECTION_BEGIN,
        payload: { inspectionId },
    };
};

export const getAppointmentTypeList = {
    pending: {
        type: ACTIONS.GET_APPOINTMENT_TYPE_LIST.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: AppointmentType[]) => ({
        type: ACTIONS.GET_APPOINTMENT_TYPE_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_APPOINTMENT_TYPE_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getLicenseListAppointment = {
    pending: {
        type: ACTIONS.GET_LICENSE_LIST_APPOINTMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: any) => ({
        type: ACTIONS.GET_LICENSE_LIST_APPOINTMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_LICENSE_LIST_APPOINTMENT.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const addAppointment = {
    pending: {
        type: ACTIONS.ADD_APPOINTMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: any) => ({
        type: ACTIONS.ADD_APPOINTMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_APPOINTMENT.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const deleteContactRecord = {
    pending: {
        type: ACTIONS.DELETE_CONTACT_RECORD.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (contactId: string, personId: string) => ({
        type: ACTIONS.DELETE_CONTACT_RECORD.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { contactId, personId },
    }),
    error: (error: Error) => ({
        type: ACTIONS.DELETE_CONTACT_RECORD.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getPersonTypes = {
    pending: () => ({
        type: ACTIONS.GET_PERSON_TYPES.PENDING,
        status: FETCH_STATUS.LOADING,
    }),
    success: (data: PersonTypeConfiguration) => ({
        type: ACTIONS.GET_PERSON_TYPES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_PERSON_TYPES.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getAppointmentDetail = {
    pending: {
        type: ACTIONS.GET_APPOINTMENT_DETAIL_BY_ID.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (appointment: Appointment, editForm: Form | undefined) => ({
        type: ACTIONS.GET_APPOINTMENT_DETAIL_BY_ID.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: {
            appointment,
            editForm,
        },
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_APPOINTMENT_DETAIL_BY_ID.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const updateAppointment = {
    pending: {
        type: ACTIONS.UPDATE_APPOINTMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Appointment) => ({
        type: ACTIONS.UPDATE_APPOINTMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.UPDATE_APPOINTMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addAppointmentComment = {
    pending: {
        type: ACTIONS.ADD_APPOINTMENT_COMMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: string) => ({
        type: ACTIONS.ADD_APPOINTMENT_COMMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_APPOINTMENT_COMMENT.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const addAppointmentCommentBegin = (data: string, appointmentId: string) => {
    return {
        type: ACTIONS.ADD_APPOINTMENT_COMMENT_BEGIN,
        payload: { data, appointmentId },
    };
};

export const getAppointmentCommentListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.APPOINTMENT_COMMENT_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const getPersonTypeFormById = {
    pending: () => ({
        type: ACTIONS.GET_PERSON_TYPE_FORM.PENDING,
        status: FETCH_STATUS.LOADING,
    }),
    success: (editForm: Form) => ({
        type: ACTIONS.GET_PERSON_TYPE_FORM.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: editForm,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_PERSON_TYPE_FORM.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getAppointmentCommentList = {
    pending: {
        type: ACTIONS.APPOINTMENT_COMMENT_LIST.PENDING,
    },
    success: (data: CommentList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.APPOINTMENT_COMMENT_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.APPOINTMENT_COMMENT_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};
export const getPersonFileList = {
    pending: {
        type: ACTIONS.GET_PERSON_FILE_LIST.PENDING,
    },
    success: (data: FileList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_PERSON_FILE_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_PERSON_FILE_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};
export const deletePersonFileDocument = {
    pending: {
        type: ACTIONS.DELETE_PERSON_FILE_DOCUMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (fileId: string) => ({
        type: ACTIONS.DELETE_PERSON_FILE_DOCUMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { fileId },
    }),
    error: (error: Error) => ({
        type: ACTIONS.DELETE_PERSON_FILE_DOCUMENT.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};
export const downloadPersonFileDocument = {
    pending: {
        type: ACTIONS.DOWNLOAD_PERSON_FILE_DOCUMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: {
        type: ACTIONS.DOWNLOAD_PERSON_FILE_DOCUMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
    },
    error: (error: Error) => ({
        type: ACTIONS.DOWNLOAD_PERSON_FILE_DOCUMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getAddContactForm = {
    pending: {
        type: ACTIONS.GET_ADD_CONTACT_FORM.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (editForm: Form) => ({
        type: ACTIONS.GET_ADD_CONTACT_FORM.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: editForm,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_ADD_CONTACT_FORM.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addBulkAppointment = {
    pending: {
        type: ACTIONS.ADD_BULK_APPOINTMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: any) => ({
        type: ACTIONS.ADD_BULK_APPOINTMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_BULK_APPOINTMENT.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const downloadPersonFileDocumentBegin = (personId: string, fileId: string, fileName: string) => {
    return {
        type: ACTIONS.DOWNLOAD_PERSON_FILE_DOCUMENT_BEGIN,
        payload: { personId, fileId, fileName },
    };
};
export const deletePersonFileDocumentBegin = (personId: string, fileId: string) => {
    return {
        type: ACTIONS.DELETE_PERSON_FILE_DOCUMENT_BEGIN,
        payload: { personId, fileId },
    };
};

export const getPersonFileListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_PERSON_FILE_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const getAppointmentTypeListBegin = () => {
    return {
        type: ACTIONS.GET_APPOINTMENT_TYPE_LIST_BEGIN,
    };
};

export const getPersonLicensesBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_PERSON_LICENSES_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const getPersonAccountingBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_PERSON_ACCOUNTING_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const getPersonDetailBegin = (id: string) => {
    return {
        type: ACTIONS.GET_PERSON_DETAIL_BEGIN,
        payload: { id },
    };
};

export const getLicenseListAppointmentBegin = (id: string) => {
    return {
        type: ACTIONS.GET_LICENSE_LIST_APPOINTMENT_BEGIN,
        payload: { id },
    };
};

export const getPersonContactsBegin = (personId: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_PERSON_CONTACTS_BEGIN,
        payload: { id: personId },
        paginationData,
    };
};

export const addPersonContactBegin = (data: Contact, personId: string) => {
    return {
        type: ACTIONS.ADD_PERSON_CONTACT_BEGIN,
        payload: { data, personId },
    };
};

export const updatePersonContactBegin = (data: Contact, personId: string, contactId: string) => {
    return {
        type: ACTIONS.UPDATE_PERSON_CONTACT_BEGIN,
        payload: { data, personId, contactId },
    };
};
export const addAppointmentBegin = (data: any) => {
    return {
        type: ACTIONS.ADD_APPOINTMENT_BEGIN,
        payload: { data },
    };
};

export const addPersonBegin = (personDetail: Person, history: any) => {
    return {
        type: ACTIONS.ADD_PERSON_BEGIN,
        payload: { personDetail, history },
    };
};

export const getAppointmentDetailsBegin = (id: string) => {
    return {
        type: ACTIONS.GET_APPOINTMENT_DETAIL_BY_ID_BEGIN,
        payload: { id },
    };
};

export const updateAppointmentBegin = (data: Appointment, appointmentId: string) => {
    return {
        type: ACTIONS.UPDATE_APPOINTMENT_BEGIN,
        payload: { data, appointmentId },
    };
};

export const deleteContactRecordBegin = (contactId: string, personId: string) => {
    return {
        type: ACTIONS.DELETE_CONTACT_RECORD_BEGIN,
        payload: { contactId, personId },
    };
};

export const getPersonCommentListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_PERSON_COMMENT_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const AddPersonCommentBegin = (comment: string, personId: string) => {
    return {
        type: ACTIONS.ADD_PERSON_COMMENT_BEGIN,
        payload: { comment, personId },
    };
};

export const getSpecificLicensesBegin = (licenseIds: string[]) => {
    return {
        type: ACTIONS.GET_SPECIFIC_LICENSES_BEGIN,
        payload: { licenseIds },
    };
};

export const getHistoryListBegin = (id: string, entityType: string) => {
    return {
        type: ACTIONS.GET_LICENSEE_HISTORY_BEGIN,
        payload: { id, entityType },
    };
};

export const getHistory = {
    pending: {
        type: ACTIONS.GET_LICENSEE_HISTORY.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: AuditHistoryList) => ({
        type: ACTIONS.GET_LICENSEE_HISTORY.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_LICENSEE_HISTORY.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getPersonTypesBegin = () => {
    return {
        type: ACTIONS.GET_PERSON_TYPES_BEGIN,
    };
};

export const getPersonTypeFormByIdBegin = (formId: string) => {
    return {
        type: ACTIONS.GET_PERSON_TYPE_FORM_BEGIN,
        payload: { id: formId },
    };
};

export const getAddPersonConfiguredFormBegin = () => {
    return {
        type: ACTIONS.GET_ADD_CONTACT_FORM_BEGIN,
    };
};

export const setAppointmentPersonList = (appointmentPersons: Person[]) => {
    return {
        type: ACTIONS.SET_APPOINTMENT_PERSONS,
        data: appointmentPersons,
    };
};

export const addBulkAppointmentBegin = (data: EventSeries) => {
    return {
        type: ACTIONS.ADD_BULK_APPOINTMENT_BEGIN,
        payload: { data },
    };
};
